export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6624.aadd8a4e.jpg";